import { memo } from "react";
import styled from "styled-components";
import { UI_Header, UI_HeaderLeft, UI_HeaderRight, UI_HeaderRight_item } from "../PanelStyle";
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { FaXmark } from "react-icons/fa6";
import { PiCheckBold, PiMapTrifoldBold } from "react-icons/pi";
import { googleBasemaps, maptilerBasemaps, showBasemapPanelAtom, selectedBasemapAtom } from "~/layouts/components/Header/components/BasemapSelector/BasemapSelectorStore";
import { BasemapMapUtil } from "~/layouts/components/Header/components/BasemapSelector/BasemapMapUtil";

const BasemapSidebarPanel = () => {
  const [showPanel, setShowPanel] = useAtom(showBasemapPanelAtom);
  const selectedBasemap = useAtomValue(selectedBasemapAtom);
  const setSelectedBasemap = useSetAtom(selectedBasemapAtom);

  const handleBasemapSelect = (basemap: any) => {
    console.log('BasemapSelector - Selected basemap:', basemap);
    setSelectedBasemap(basemap);
    BasemapMapUtil.changeBasemap(basemap);
    setShowPanel(false); // Close panel after selection
  };

  return (
    <UI_Wrapper>
      {/* Header */}
      <UI_Header>
        <UI_HeaderLeft style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <PiMapTrifoldBold style={{ color: '#2563eb', fontSize: '18px' }} />
          <span>Bản đồ nền</span>
        </UI_HeaderLeft>
        <UI_HeaderRight>
          <UI_HeaderRight_item onClick={() => {
            setShowPanel(false);
          }}>
            <FaXmark />
          </UI_HeaderRight_item>
        </UI_HeaderRight>
      </UI_Header>
      {/* End Header */}

      {/* Content */}
      <UI_Content>
        <UI_Group_Header>Nền vector</UI_Group_Header>
        <UI_BasemapGrid>
          {maptilerBasemaps.map((basemap, index) => {
            const isSelected = selectedBasemap?.url === basemap.url;
            return (
              <UI_BasemapItem
                key={index}
                className={isSelected ? 'selected' : ''}
                onClick={() => {
                  handleBasemapSelect(basemap);
                }}
              >
                <UI_BasemapImage>
                  <img src={basemap.image} alt={basemap.title} />
                </UI_BasemapImage>
                <UI_BasemapTitle>{basemap.title}</UI_BasemapTitle>
                {isSelected && <UI_SelectedIndicator><PiCheckBold size={12} /></UI_SelectedIndicator>}
              </UI_BasemapItem>
            )
          })}
        </UI_BasemapGrid>

        <UI_Group_Header>Nền google</UI_Group_Header>
        <UI_BasemapGrid>
          {googleBasemaps.map((basemap, index) => {
            const isSelected = selectedBasemap?.url === basemap.url;
            return (
              <UI_BasemapItem
                key={index}
                className={isSelected ? 'selected' : ''}
                onClick={() => {
                  handleBasemapSelect(basemap);
                }}
              >
                <UI_BasemapImage>
                  <img src={basemap.image} alt={basemap.title} />
                </UI_BasemapImage>
                <UI_BasemapTitle>{basemap.title}</UI_BasemapTitle>
                {isSelected && <UI_SelectedIndicator><PiCheckBold size={12} /></UI_SelectedIndicator>}
              </UI_BasemapItem>
            )
          })}
        </UI_BasemapGrid>
      </UI_Content>
    </UI_Wrapper>
  )
}

export default memo(BasemapSidebarPanel);

const UI_Wrapper = styled.div`
  width: 300px;
  height: 500px;
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  @media (max-width: 768px) {
    width: 280px;
    right: 12px;
  }

  @media (max-width: 480px) {
    width: calc(100vw - 16px);
    left: 8px;
    right: 8px;
    top: 10px;
    height: calc(100vh - 80px);
  }
`;

const UI_Content = styled.div`
  padding: 16px;
  height: calc(100% - 40px);
  overflow-y: auto;
`;

const UI_Group_Header = styled.div`
  padding: 8px 0;
  color: #666;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;

  &:not(:first-child) {
    margin-top: 24px;
  }
`;

const UI_BasemapGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
`;

const UI_BasemapItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background-color: #f5f5f5;
    border-color: #ddd;
  }

  &.selected {
    border-color: var(--color-primary, #1890ff);
    background-color: rgba(24, 144, 255, 0.05);
  }
`;

const UI_BasemapImage = styled.div`
  width: 80px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const UI_BasemapTitle = styled.div`
  font-size: 12px;
  text-align: center;
  color: #333;
  line-height: 1.3;
`;

const UI_SelectedIndicator = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  background-color: var(--color-primary, #1890ff);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
`;